// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"styles_chartWrapper__2svHw","positionIcon":"styles_positionIcon__36ZiG"};